// emp-shift.js
import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Select from 'react-select';
import EmpLayout from '../../components/EmpScheduleLayout.jsx';
import { Form } from 'react-bootstrap';
import axios from '../../Authservices/axiosInstance';
import './emp-shift.css';

export default function EmpShift() {
  const { userId } = useParams();
  const location = useLocation();
  const [shift, setShift] = useState(location.state?.shift || null);

  const shiftOptions = [
    { value: 'AM', label: 'Morning' },
    { value: 'PM', label: 'Evening' }
  ];

  useEffect(() => {
    async function fetchShift() {
      if (!shift) {
        try {
          const response = await axios.get(`https://backend.ems.uk.hiradentallab.com/api/timings/${userId}`);
          setShift(response.data.shift);
        } catch (error) {
          console.error("Error fetching shift:", error);
        }
      }
    }

    fetchShift();
  }, [userId, shift]);

  return (
    <EmpLayout>
      <div className="emp-shift-container">
        <Form.Group controlId="shift-select">
          <Form.Label className="shift-label">Selected Shift:</Form.Label>
          <Select
            value={shiftOptions.find(option => option.value === shift)}
            isDisabled
            options={shiftOptions}
            placeholder="--Shift--"
            className="shift-select"
            classNamePrefix="select"
          />
        </Form.Group>
      </div>
    </EmpLayout>
  );
}
